import React, { FC, useEffect } from 'react';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { Box, Paper, duration, Button } from '@material-ui/core';
import Typo from '../../Components/Typo';
import TestimonialCard, { TTestimonial } from './TestimonialCard';
import { uniqueId } from 'lodash';
import gsap from 'gsap';
import useHorizontalList from '../../Components/HorizontalList/useHorizontalList';

export interface TestimonialListProps {
    list: TTestimonial[]
}
export const TESTIMONIAL_CARD = 'card-testimonial';

const TestimonialList: FC<TestimonialListProps> = (props) => {
    const classes = useStyles();
    const id = uniqueId('testimonial-list');
    const { list = [] } = props;


    useEffect(() => {
        gsap.fromTo(`.${TESTIMONIAL_CARD}`, {
            opacity: 0,
            x: 200,
        }, {
            scrollTrigger: {
                trigger: `#${id}`,
                toggleActions: 'restart pause',
            },

            opacity: 1,
            duration: 1,
            x: 0,
            ease: "power1.inOut",
            stagger: {
                // from: "edges",
                amount: 0.5
            }
        })

        gsap.to(`.${TESTIMONIAL_CARD}`, {
            scrollTrigger: {
                trigger: `#${id}`,
                scrub: 1,
                toggleActions: 'restart pause',
            },
            position: 'relative',
            left: 100,
            stagger: 0.1
        })
    }, [])





    return (
        <Box id={id} display='flex'  >
            {list.map((item, i) => (
                <Box m={4} key={i} className={TESTIMONIAL_CARD}>
                    <TestimonialCard item={item} />
                </Box>
            ))}
        </Box>
    )
}

const useStyles = makeStyles<Theme, any>((theme) => ({

}));

export default TestimonialList;